import * as Redux from 'redux'
import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'
import reducer from './reducer'

// const logger = createLogger();

export default Redux.createStore(
    reducer,
    Redux.applyMiddleware(thunk/*, logger*/)
);



// WEBPACK FOOTER //
// ./src/store.tsx